import makeCrud from '@/store/site/localization/crud'

// Marka listesi standart sayfalı sözleşmeyi (data + meta) kullanır; çok dilli
// alanlar (title/slug/meta) kategori gibi istek başına tek dil (language_id) gönderilir,
// payload'ı sayfa oluşturur → ortak CRUD store fabrikası yeterli.
export default makeCrud('ecommerce_product_brand')
